import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AngleAdventure = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [anglesCompleted, setAnglesCompleted] = useState(0);

  const angleQuestions = [
    { question: "What is the measure of a right angle?", answer: 90, unit: "°" },
    { question: "Two angles that add up to 180° are called?", answer: "supplementary", unit: "" },
    { question: "If one angle is 45°, what is its complementary angle?", answer: 45, unit: "°" },
    { question: "A straight angle measures:", answer: 180, unit: "°" },
    { question: "If angle A = 60° and angle B = 120°, are they supplementary?", answer: "yes", unit: "" },
    { question: "An acute angle is less than:", answer: 90, unit: "°" },
    { question: "Two angles that add up to 90° are called?", answer: "complementary", unit: "" },
    { question: "An obtuse angle is greater than:", answer: 90, unit: "°" },
    { question: "If one angle is 30°, what is its complementary angle?", answer: 60, unit: "°" },
    { question: "If one angle is 70°, what is its supplementary angle?", answer: 110, unit: "°" },
    { question: "How many degrees in a complete rotation?", answer: 360, unit: "°" },
    { question: "A reflex angle is greater than:", answer: 180, unit: "°" },
  ];

  const generateQuestion = () => {
    const q = angleQuestions[Math.floor(Math.random() * angleQuestions.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = userAnswer.toLowerCase().trim();
    const correct = answer === String(question.answer).toLowerCase();

    if (correct) {
      setScore(score + 15);
      setAnglesCompleted(anglesCompleted + 1);
      setFeedback('✅ Correct!');
      setTimeout(generateQuestion, 1500);
    } else {
      setFeedback(`❌ Wrong! Answer: ${question.answer}${question.unit}`);
      setTimeout(generateQuestion, 2500);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-500 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-300">← Back</button>
            <h1 className="text-3xl font-bold">📐 Angle Adventure</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">📐</div>
            <h2 className="text-2xl font-bold text-gray-800">Master Lines & Angles!</h2>
            <p className="text-gray-600">Angles Completed: {anglesCompleted}</p>
          </div>

          {question && (
            <div className="text-center">
              <div className="text-xl font-bold text-indigo-700 mb-6">{question.question}</div>
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <input
                  type="text"
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="w-full text-3xl text-center border-4 border-indigo-300 rounded-lg p-4 mb-4 focus:border-indigo-500 focus:outline-none"
                  placeholder="Your answer"
                  autoFocus
                />
                <button type="submit" className="w-full bg-indigo-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-indigo-700">
                  Submit
                </button>
              </form>
              {feedback && (
                <div className={`mt-4 text-xl font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}

          <div className="mt-8 p-4 bg-blue-50 rounded-lg text-sm">
            <p><strong>💡 Remember:</strong></p>
            <p>• Right angle = 90°</p>
            <p>• Straight angle = 180°</p>
            <p>• Complementary angles add to 90°</p>
            <p>• Supplementary angles add to 180°</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AngleAdventure;